// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

import './HeaderFooter.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="page-content">
        <div className="logo-container">
          {/* Ajuste o src/alt conforme seu logo de rodapé */}
          <img src="/images/logo-codi-edu.png" alt="Plataforma CODI"/>
        </div>

        <nav id="menu-footer">
          <div className="menu-item">
            <Link to="/sobre">Sobre nós</Link>
          </div>
          <div className="menu-item">
            <Link to="/faq">FAQ</Link>
          </div>
          <div className="menu-item">
            <Link to="/privacidade">Privacidade</Link>
          </div>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
